import { apolloClient } from '@/vue-apollo'

export const addToSubscriptions = (query, variables, callback) => {
  const sub = apolloClient.subscribe({
    query,
    variables,
    fetchPolicy: 'no-cache'
  }).subscribe({
    next (res) {
      callback(res.data)
    },
    error (error) {
      console.error('Subscription error:', error)
    }
  })
  return sub
}
